import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
// import Card from '@gerenciatd/next.components.card-n';
import styles from './styles';

const FakeMyData = () => {
  const parentDiv = document.getElementsByClassName('container')[0] || window;
  const contentWidth = parentDiv.clientWidth || window.innerWidth;

  if (contentWidth < 767) {
    return (
      <div className="FakeMyData">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              {/* <Card> */}
                <ContentLoader
                  height="395"
                  width={contentWidth}
                  {...fakeSettings}
                >
                  <rect x={(contentWidth / 2) - 60} y="10" rx="1" ry="1" width="120" height="22.5" />

                  <rect x="10" y="90" width="100" height="20" />
                  <rect x="10" y="120" width="220" height="20" />

                  <rect x="10" y="170" width="150" height="20" />
                  <rect x="10" y="200" width="130" height="20" />

                  <rect x="10" y="250" width="150" height="20" />
                  <rect x="10" y="280" width="270" height="20" />

                  <rect x={(contentWidth / 2) - 75} y="350" rx="1" ry="1" width="150" height="22.5" />
                </ContentLoader>
              {/* </Card> */}
            </div>
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    );
  }
  return (
    <div className="FakeMyData">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <Card>
              <ContentLoader
                height="255"
                width={contentWidth}
                {...fakeSettings}
              >
                <rect x={(contentWidth / 2) - 60} y="10" rx="1" ry="1" width="120" height="22.5" />

                <rect x="10" y="80" width="120" height="20" />
                <rect x="10" y="110" width="240" height="20" />

                <rect x="400" y="80" width="170" height="20" />
                <rect x="400" y="110" width="120" height="20" />

                <rect x="630" y="80" width="150" height="20" />
                <rect x="630" y="110" width="220" height="20" />

                <rect x={(contentWidth / 2) - 75} y="220" rx="1" ry="1" width="150" height="22.5" />
              </ContentLoader>
            </Card>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}


export default FakeMyData;
